<template>
    <div v-if="form.status === 5" class="detail-card gray">
        <div class="card-header">
            <div class="title">已撤銷</div>
        </div>
        <div class="card-body">
            <el-row :gutter="40">
                <el-col :sm="14">
                    <spec-view>
                        <spec-item label="撤銷原因">
                            {{ form.foO_CNL_MEM }}
                        </spec-item>
                    </spec-view>
                </el-col>
                <el-col :sm="10">
                    <spec-view>
                        <spec-item label="撤銷人">
                            {{ form.foO_CNL_CRT_NAM }}
                        </spec-item>
                        <spec-item label="撤銷日期">
                            {{ form.foO_CNL_DAT | dateFormater("YYYY-MM-dd") }}
                        </spec-item>
                    </spec-view>
                </el-col>
            </el-row>
            <br />
            <el-alert v-if="isIncomeExist || isProjectExist" :closable="false">
                <ul>
                    <li v-if="isIncomeExist">撤銷後，營業收入、出入帳紀錄將不會計算此單。</li>
                    <li v-if="isProjectExist">恢復原專案分期。</li>
                </ul>
            </el-alert>
        </div>
    </div>
</template>

<script>
import SpecView from '@/components/ui/SpecView/SpecView.vue';
import SpecItem from '@/components/ui/SpecView/SpecItem.vue';

export default {
    computed: {
        isIncomeExist() {
            return this.form.incomes?.length;
        },
        isProjectExist() {
            return this.form.projects?.length;
        },
    },
    props: {
        form: {
            type: Object,
            default: () => {},
        },
    },
    components: { SpecView, SpecItem },
};
</script>
